import { useTooltip } from '@frontend/design-system';
import { StatusChip } from '../status-chip';
import { DisabledStatusChipProps } from './types';
import { Wrapper } from './wrapper';

export const DisabledStatusChip = ({ disabledTooltipText, wrapperStyle, ...restProps }: DisabledStatusChipProps) => {
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({});

  if (!disabledTooltipText) {
    return (
      <Wrapper wrapperStyle={wrapperStyle}>
        <StatusChip {...restProps} disabled />
      </Wrapper>
    );
  }

  return (
    <>
      <Wrapper wrapperStyle={wrapperStyle}>
        <StatusChip {...restProps} {...triggerProps} disabled />
      </Wrapper>
      <Tooltip {...tooltipProps}>{disabledTooltipText}</Tooltip>
    </>
  );
};
